import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { industriesData } from '../../data/industriesData';


const UnmatchedIndustryExpertise = () => {
  return (
    <section className="w-full bg-white py-16 lg:py-[80px]">
      <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
        <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] mb-[50px] text-left">
          Unmatched Industry Expertise
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {Object.values(industriesData).map((item) => (
            <div
              key={item.id}
              className="group relative h-[350px] md:h-[400px] w-full overflow-hidden cursor-pointer"
            >
              <Link to={`/industries/${item.id}`}>
                <div className="absolute inset-0 w-full h-full">
                  <img
                    src={item.heroImg}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-all duration-300"></div>
                </div>
                <div className="absolute bottom-0 left-0 w-[85%] bg-white p-6 md:p-8 shadow-lg transition-all duration-500 ease-in-out">
                  <h3 className="text-[#01386A] font-sora lg:text-[20px] text-[16px] font-[600] mb-2 group-hover:mb-4 transition-all duration-300">
                    {item.title}
                  </h3>
                  <div className="max-h-0 opacity-0 overflow-hidden transition-all duration-500 ease-in-out group-hover:max-h-[200px] group-hover:opacity-100">
                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik font-[500] leading-relaxed mb-4">
                      {item.overviewText}
                    </p>
                    <div className="flex items-center gap-2 text-[#01386A] font-[500] font-graphik text-[14px] md:text-[16px] pb-2">
                      <span>Read More</span>
                      <ArrowRight
                        size={18}
                        className="transform transition-transform duration-300 group-hover:translate-x-2"
                      />
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 h-[4px] w-full bg-[#01386A]"></div>
                  <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                </div>
              </Link>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default UnmatchedIndustryExpertise;